export enum BillingPrivilege {
view = 'VIEW_BILLING',
edit = 'EDIT_BILLING',
merchantBilling = 'MERCHANT_BILLING'
}